module.exports = __webpack_public_path__ + "img/Avatar-18.07ef9066.svg";